import * as amplitude from "@amplitude/unified";

/**
 * Initialize Amplitude (analytics + optional session replay) in the browser.
 * Call once when the app loads. No-op outside production or if AMPLITUDE_API_KEY is not set.
 */
export function initAmplitude() {
  if (typeof ENV === "undefined" || ENV.MODE !== "production") return;
  const apiKey = typeof ENV !== "undefined" && ENV.AMPLITUDE_API_KEY?.trim();
  if (!apiKey) return;

  void amplitude.initAll(apiKey, {
    analytics: {
      autocapture: {
        pageViews: false,
        sessions: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
      },
    },
    sessionReplay: {
      sampleRate: 0.1, // 10% of sessions; increase or set to 1 for 100%
    },
  });
}

/**
 * Track a custom event. Use after initAmplitude() has run.
 * @example amplitude.track('Sign Up')
 */
export function track(
  eventName: string,
  eventProperties?: Record<string, unknown>,
) {
  try {
    if (eventProperties) {
      amplitude.track(eventName, eventProperties);
    } else {
      amplitude.track(eventName);
    }
  } catch {
    // no-op if Amplitude not initialized or tracking fails
  }
}
